import type { SuretyAccountId } from "@inrev/common";
import type { FC } from "react";
import { cn } from "../lib/utils";
import { Spinner } from "../primitives/Spinner";
import { usePendingExtractions } from "./hooks/useHasPendingExtractions";

export type PendingExtractionsIndicatorProps = {
	accountId: SuretyAccountId;
	className?: string;
};

export const PendingExtractionsIndicator: FC<PendingExtractionsIndicatorProps> = ({
	accountId,
	className,
}) => {
	const { hasPendingFinancial } = usePendingExtractions(accountId);

	if (!hasPendingFinancial) {
		return null;
	}

	return (
		<div
			data-testid="pending-extractions-indicator"
			className={cn("flex items-center gap-2 text-sm text-tertiary italic", className)}
		>
			<Spinner size="sm" />
			Extracting...
		</div>
	);
};
